/*
 * EditControl Messages
 *
 * This contains all the text for the EditControl component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  create: {
    id: 'app.components.EditControl.create',
    defaultMessage: 'Create new route',
  },
  edit: {
    id: 'app.components.EditControl.edit',
    defaultMessage: 'Edit current route',
  },
  copy: {
    id: 'app.components.EditControl.copy',
    defaultMessage: 'Edit copy of current route',
  },
  save: {
    id: 'app.components.EditControl.save',
    defaultMessage: 'Save route',
  },
  undo: {
    id: 'app.components.EditControl.undo',
    defaultMessage: 'Undo last action',
  },
  clear: {
    id: 'app.components.EditControl.clear',
    defaultMessage: 'Clear route',
  },
  confirm: {
    id: 'app.components.EditControl.confirm',
    defaultMessage: 'Changes are not saved. Continue?',
  },
  loginFirst: {
    id: 'app.components.EditControl.loginFirst',
    defaultMessage: 'You need to sign in to save a route',
  },
});
